/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-body-font-style',
  templateUrl: './theme-option-tooltips-body-font-style.component.html',
  styleUrls: ['./theme-option-tooltips-body-font-style.component.css']
})
export class ThemeOptionTooltipsBodyFontStyleComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_bodyFontStyle';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_bodyFontStyle', value);
  }

}
